import FieldCurrency from "../currency/currency"
import FieldConfig from "../../../proto/field-config"
import {GROUP_FINANCE} from "../../../../gd/const/fields/field2-groups"
import AggregateNumber from "../../../../fields/aggregate/aggregate-number"
import AggregateCost from "../../../../fields/system/cost/components/aggregate-cost"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"

const debug = false
// const debug = "FieldEstimatedCost"

export default class FieldEstimatedCost extends FieldCurrency {

    constructor(config:FieldConfig) {
        super(config)

        this.typeGroup          = GROUP_FINANCE


        // this.renderComponents.tableCell     = FieldEstimatedCost_TableCell
    }

    getAggregateClass() {
        return AggregateNumber
    }

    getAggregateOptions() {return [
        AggregateFunctionType.SUM,
        AggregateFunctionType.MIN,
        AggregateFunctionType.MAX,
        AggregateFunctionType.MEDIAN,
        AggregateFunctionType.AVERAGE
    ]}

    getDefaultAggregateFunction() {
        return AggregateFunctionType.SUM
    }

    get AggregateComponent() {return AggregateCost.bind(null, this.getAggregateOptions())}


    // Formula compatability
    getValueType() {
        return gd.const.fields.valueType.FLOAT
    }

    getFormulaValue(model:any) {

        const result = this.getViewValue(model)
        if (!result) return 0

        return result
    }
}
